import { useState, useCallback, type JSX } from 'react'
import { Sun, Moon } from 'lucide-react'
import { cn } from '@/lib/utils'

export function ThemeToggle(): JSX.Element {
  const [isDark, setIsDark] = useState((): boolean =>
    document.documentElement.classList.contains('dark'),
  )

  const toggle = useCallback((): void => {
    const next = !isDark
    setIsDark(next)
    document.documentElement.classList.toggle('dark', next)
    try {
      localStorage.setItem('pipefile-creator:theme', next ? 'dark' : 'light')
    } catch {
      // localStorage may be unavailable
    }
  }, [isDark])

  return (
    <button
      onClick={toggle}
      className={cn(
        'flex h-8 w-8 items-center justify-center rounded-md',
        'text-muted-foreground transition-colors',
        'hover:bg-accent hover:text-foreground',
      )}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  )
}
